"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withCircuitBreaker = exports.CircuitBreakerError = void 0;
var _asyncMutex = require("async-mutex");
class CircuitBreakerError extends Error {
  constructor(message) {
    super(message);
    this.name = "CircuitBreakerError";
  }
}
exports.CircuitBreakerError = CircuitBreakerError;
var State = function (State) {
  State[State["CLOSED"] = 0] = "CLOSED";
  State[State["OPEN"] = 1] = "OPEN";
  State[State["HALF_OPEN"] = 2] = "HALF_OPEN";
  return State;
}(State || {});
class CircuitBreaker {
  mutex = new _asyncMutex.Mutex();
  state = State.CLOSED;
  counts = {
    consecutiveFailures: 0,
    halfOpenRequests: 0
  };
  lastStateChange = Date.now();
  constructor(options) {
    this.options = applyDefaultOptions(options);
  }
  canRequest() {
    if (this.state === State.CLOSED) {
      return Promise.resolve();
    }
    if (this.state === State.OPEN) {
      const now = Date.now();
      if (now - this.lastStateChange >= this.options.timeout) {
        this.toHalfOpen();
        return this.canRequestInHalfOpen();
      }
      return Promise.reject(new CircuitBreakerError("Circuit breaker is open"));
    }
    return this.canRequestInHalfOpen();
  }
  canRequestInHalfOpen() {
    if (this.counts.halfOpenRequests < this.options.maxRequests) {
      return Promise.resolve();
    }
    return Promise.reject(new CircuitBreakerError("Circuit breaker is half open and reached max requests"));
  }
  async beforeRequest() {
    const release = await this.mutex.acquire();
    try {
      await this.canRequest();
      if (this.state === State.HALF_OPEN) {
        this.counts.halfOpenRequests++;
      }
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    } finally {
      release();
    }
  }
  onSuccess() {
    if (this.state === State.HALF_OPEN) {
      this.counts.halfOpenRequests--;
      this.toClose();
    }
    this.counts.consecutiveFailures = 0;
  }
  onError(error) {
    var _error$response;
    const statusCode = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status;
    if (!statusCode) {
      return;
    }
    if (this.options.failureStatusCodes.includes(statusCode)) {
      this.incrementFailureCount();
    }
  }
  incrementFailureCount() {
    this.counts.consecutiveFailures++;
    if (this.options.failuresThreshold <= this.counts.consecutiveFailures) {
      this.toOpen();
    }
  }
  toOpen() {
    this.state = State.OPEN;
    this.lastStateChange = Date.now();
  }
  toHalfOpen() {
    this.state = State.HALF_OPEN;
    this.lastStateChange = Date.now();
  }
  toClose() {
    this.state = State.CLOSED;
    this.lastStateChange = Date.now();
    this.counts = {
      consecutiveFailures: 0,
      halfOpenRequests: 0
    };
  }
}
const applyDefaultOptions = opt => {
  return {
    ...opt,
    maxRequests: opt.maxRequests || 1,
    timeout: opt.timeout || 60 * 1000,
    failuresThreshold: opt.failuresThreshold || 5
  };
};
const withCircuitBreaker = opt => {
  const breaker = new CircuitBreaker(opt);
  return {
    request: async config => {
      try {
        await breaker.beforeRequest();
        return Promise.resolve(config);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    response: response => {
      breaker.onSuccess();
      return Promise.resolve(response);
    },
    error: error => {
      breaker.onError(error);
      return Promise.reject(error);
    }
  };
};
exports.withCircuitBreaker = withCircuitBreaker;
//# sourceMappingURL=circuitbreaker.js.map